import gql from 'graphql-tag';
import {unitMessageFragments} from '@homeaway/react-urgency-messaging';

export const urgencyMessageFragments = {
    Listing: gql`
        fragment UrgencyMessageListing on Listing {
            unitMessage(assetVersion: 1) {
                ...UnitMessageUnitMessage
            }
        }
        ${unitMessageFragments.UnitMessage}
    `
};
